import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import getMSA from '../services/getMSA';
import './CheckoutMSA.scss';

function CheckoutMSA({ values, devicePrice, shippingFee, selectedCard, renderButtons }) {
  const [file, setFile] = useState(null);
  useEffect(() => {
    async function init() {
      const result = await getMSA({ ...values, devicePrice, shippingFee, subscriptionCharge: selectedCard.priceId });
      setFile(result);
    }

    init();
  }, []);

  return (
    <div id="checkoutConfirmedForm" className="checkoutMSA">
      <div className="main_container grid">
        <div className="data_container">
          <div className="grid">
            <div className="col-12 flex align-items-center header">
              <div className="header_number">4</div>
              <div className="header_text_box">
                <p className="step_text_mobile">Step 4 of 5</p>
                <h2 className="header_title">Service Agreement</h2>
              </div>
            </div>
            <div className="contract-content">
              <div className="sub-header col-12">{file && <iframe src={`${file}#toolbar=0`} title="msa" />}</div>
            </div>
          </div>
          {renderButtons()}
        </div>
      </div>
    </div>
  );
}

CheckoutMSA.propTypes = {
  values: PropTypes.shape({
    businessAddress: PropTypes.string.isRequired,
    businessAddress2: PropTypes.string,
    firstName: PropTypes.string.isRequired,
    businessEmail: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    zipCode: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    billingCity: PropTypes.string.isRequired,
    billingCountry: PropTypes.string.isRequired,
    billingZipCode: PropTypes.string.isRequired,
    billingAddress: PropTypes.string,
    billingAddress2: PropTypes.string,
    numberOfDevices: PropTypes.number.isRequired,
    billingPlan: PropTypes.string,
  }).isRequired,
  devicePrice: PropTypes.number,
  shippingFee: PropTypes.number,
  selectedCard: PropTypes.objectOf(PropTypes.any),
  renderButtons: PropTypes.any,
};

CheckoutMSA.defaultProps = {
  devicePrice: undefined,
  shippingFee: undefined,
  selectedCard: undefined,
  renderButtons: () => {},
};

export default CheckoutMSA;
